import React, { useState, useEffect } from 'react';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const HeroCarousel = ({ onWhatsAppOrder, onCallOrder }) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const heroSlides = [
  {
    id: 1,
    image: "https://i.ibb.co/230jxVDR/Customer-3.jpg",
    imageAlt: "Freshly made golden brown chapati flatbreads stacked on traditional wooden plate with steam rising in warm restaurant kitchen lighting",
    title: "From the team with love",
    subtitle: "Experience the taste of tradition with modern convenience",
    cta: "Order Now on WhatsApp"
  },
  {
    id: 2,
    image: "https://i.ibb.co/Mytn14ZY/Customer.jpg",
    imageAlt: "Delicious hot rolex with chilled drink and fresh toppings on wooden serving board in cozy restaurant setting with warm ambient lighting",
    title: "Fast Food, Fresh Ingredients",
    subtitle: "Quality meals delivered to your door daily",
    cta: "Call Us Now"
  },
   {
    id: 3,
    image: "https://i.ibb.co/Mytn14ZY/Customer.jpg",
    imageAlt: "Delicious hot rolex with chilled drink and fresh toppings on wooden serving board in cozy restaurant setting with warm ambient lighting",
    title: "Fast Food, Fresh Ingredients",
    subtitle: "Quality meals delivered to your door daily",
    cta: "Call Us Now"
  },
  {
    id: 4,
    image: "https://i.ibb.co/LDzXQ53W/Veg-Rolex.jpg",
    imageAlt: "Gourmet burger with juicy beef patty, fresh lettuce, tomatoes, and melted cheese on sesame seed bun served on rustic wooden table",
    title: "Taste The Difference",
    subtitle: "Proudly serving Juba with love since 2020",
    cta: "Explore Menu"
  }];


  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroSlides?.length);
    }, 5000);

    return () => clearInterval(timer);
  }, [heroSlides?.length]);

  const handleSlideChange = (index) => {
    setCurrentSlide(index);
  };

  const handleCTAClick = (slideId) => {
    if (slideId === 1) {
      onWhatsAppOrder();
    } else if (slideId === 2) {
      onCallOrder();
    } else {
      window.scrollTo({ top: document.getElementById('featured-menu')?.offsetTop || 800, behavior: 'smooth' });
    }
  };

  return (
    <div className="relative w-full h-[500px] md:h-[600px] lg:h-[700px] overflow-hidden bg-muted">
      {heroSlides?.map((slide, index) =>
      <div
        key={slide?.id}
        className={`absolute inset-0 transition-opacity duration-1000 ${
        index === currentSlide ? 'opacity-100 z-10' : 'opacity-0 z-0'}`
        }>

          <div className="relative w-full h-full">
            <Image
            src={slide?.image}
            alt={slide?.imageAlt}
            className="w-full h-full object-cover" />

            <div className="absolute inset-0 flex items-end pb-16 md:pb-24">
              <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 w-full">
                <div className="max-w-2xl">
                  <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white md:mb-6 leading-tight mb-4">
                    {slide?.title}
                  </h1>
                  <p className="text-lg md:text-xl lg:text-2xl text-white/90 mb-6 md:mb-8">
                    {slide?.subtitle}
                  </p>
                  <Button
                  variant="default"
                  size="lg"
                  iconName="MessageCircle"
                  iconPosition="left"
                  onClick={() => handleCTAClick(slide?.id)}
                  className="bg-primary hover:bg-primary/90">

                    {slide?.cta}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-20 flex gap-3">
        {heroSlides?.map((_, index) =>
        <button
          key={index}
          onClick={() => handleSlideChange(index)}
          className={`w-3 h-3 rounded-full transition-all duration-300 ${
          index === currentSlide ?
          'bg-primary w-8' : 'bg-white/50 hover:bg-white/75'}`
          }
          aria-label={`Go to slide ${index + 1}`} />

        )}
      </div>
    </div>);

};

export default HeroCarousel;